<template>

  <el-notification
    :notification="notification"
    :module="$t('modules.event.title')"
    :date="notification.created_at"
    :title="$t('modules.event.notifications.event', { content: notification.data.data.content_name })"
  >
    <div slot="actions">
      <el-notification-button
        :notification="notification"
        :callback="goToContent"
        :title="$t('modules.event.notifications.btn_event')"
      />
    </div>
  </el-notification>

</template>

<script>

export default {
  tag: 'el-notification-event-event',
  name: 'NotifeventContentNew',
  props: {
    notification: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    goToContent (notification) {
      return this.$router.push({
        name: 'module.index',
        params: {
          world: this.world.id,
          module: 'event',
          page: 'events',
        },
        hash: '#' + notification.data.data.content_id,
      })
    },
  },
  computed: {
    world () {
      return this.$store.getters['auth/getWorld']
    },
  },
}
</script>

<style scoped lang="scss">

</style>
